import React from 'react';
import Icon from 'react-icon-base';

const Fr = (props) => {
  return (
    <Icon viewBox="0 0 640 480" {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2">
      <rect width="3" height="2" fill="#ED2939"/>
      <rect width="2" height="2" fill="#fff"/>
      <rect width="1" height="2" fill="#002395"/>
    </svg>
    </Icon>
  );
};

export default Fr;
